var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forbidden-page"},[_c('h2',[_vm._v("403 无权访问")]),_c('p',[_vm._v("你没有访问该页面的权限。如需申请,请联系管理员在「系统管理 - 角色管理」中授权。")]),_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goHome}},[_vm._v("返回首页")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }